import React, { useContext } from 'react'
import Parser from 'html-react-parser';
import { FormContext } from '../../FormContext';

const Description = ({field_label,field_column}) => {
    const { formAdmin } = useContext(FormContext);

    return (
        <>
         <div class={`${field_column? field_column:'col-sm-12'}`}>
            {Parser(field_label)}
        </div>
        </>
    )
}

export default Description
